/**
 * i18n/index.ts — vue-i18n configuration
 *
 * Loads locale messages from JSON files.
 * Default locale: English (en).
 * Add new locales by creating src/i18n/locales/<code>.json
 * and adding the import here.
 */

import { createI18n } from 'vue-i18n';

import en from './locales/en.json';

export type MessageSchema = typeof en;

export const i18n = createI18n<[MessageSchema], 'en'>({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en,
    },
});
